/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery');
require('bootstrap');

$(document).ready(function () {

	window.submitEmailDownload = function(e){
		e.preventDefault();
		let email = $('#email').val();
		$.ajaxSetup({
		   headers: {
		      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		   }
		});
		$.ajax({
			url: $(e.target).attr('action'),
			type:"POST",
			data:{
				ek_email: email
			},
			success:function(response){
				if(response.success) {
					$('#alerts').html('');
					$('#modalDownload').modal('toggle');
					download(case_study_url);
					$('#download_button').removeAttr('data-toggle').removeAttr('data-target').click(function() {
						download(case_study_url);
					});
				} else {
					$('#alerts').html('<div class="alert alert-primary" role="alert">The email must be a valid email address.</div>');
				}
			},
			error: function(response) {
				if(response.responseJSON.errors.ek_email) {
					$('#alerts').html('<div class="alert alert-primary" role="alert">The email must be a valid email address.</div>');
				}
			},
		});
	}

	function download(url) {
	  const a = document.createElement('a')
	  a.href = url
	  a.download = url.split('/').pop()
	  document.body.appendChild(a)
	  a.click()
	  document.body.removeChild(a)
	}

    // //Function animate on scroll
    // function scrollTrigger(selector, options = {}) {
    //     let elements = document.querySelectorAll(selector);
    //     Array.from(elements).forEach(element => {
    //         addObserver(element, options);
    //     })
    // }

    // function addObserver(element, options) {
    //     let observer = new IntersectionObserver((entries, observer) => {
    //         //console.log(entries, observer);
    //         entries.forEach(entry => {
    //             if(entry.isIntersecting) {
    //                 entry.target.classList.add('active');
    //                 observer.unobserve(entry.target);
    //             }
    //         })
    //     }, options)

    //     observer.observe(element);
    // }

    // function getThresholdBasedOnScreenWidth() {
    //     const screenWidth = window.innerWidth;

    //     if(screenWidth < 700) {
    //         return 0.25;
    //     } else {
    //         return 0.75;
    //     }
    // }

    // scrollTrigger(".animate-column", {
    //     // threshold: .25,
    //     threshold: getThresholdBasedOnScreenWidth(),
    // });

    //check page Y Offset on scrolling and add position fixed on NAVBAR
    const navbar = document.getElementById("header");
    const offset = 0;
    let isNavbarFixed= false;

    function updateNavbar() {
        if(window.scrollY > offset && !isNavbarFixed) {
            navbar.classList.add('fixed');
            isNavbarFixed = true;
        } else if(window.scrollY <= offset && isNavbarFixed) {
            navbar.classList.remove('fixed');
            isNavbarFixed = false;
        }
    }
    function handleScroll() {
        requestAnimationFrame(updateNavbar);
    }

    window.addEventListener("scroll", handleScroll);
    //initial on page load
    updateNavbar();

	//function get URL for highlighing link-menu in navbar
    const linksNavbar = Array.from(document.querySelectorAll('.navbar-nav .nav-item'));
    linksNavbar.forEach(link => {
        link.addEventListener('click', function() {
            setTimeout(() => {
                // Remove 'active' class from all links
                linksNavbar.forEach(otherLink => {
                    otherLink.children[0].classList.remove('active');
                });
                // Add 'active' class to the clicked link
                if (link.children[0].hash === window.location.hash) {
                    link.children[0].classList.add('active');
                    //console.log(link.children[0].classList.contains('active'));
                }
            },0)
        })
    })
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js